import { useSelector } from "react-redux";
import { io, Socket } from "socket.io-client";
import { RootState } from "../redux/store";
import { useEffect, useState } from "react";
import { SocketContext } from "../context/socketContext";
import { getClientDomain } from "../utils/functions/client-code";
import { v4 as uuidv4 } from "uuid";

export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
  const auth = useSelector((state: RootState) => state.auth);
  const [socket, setSocket] = useState<Socket | null>(null);
  const clientCode = getClientDomain();
  const requestId = uuidv4();
  useEffect(() => {
    if (auth.isLoggedIn && auth.client?.client_code && clientCode) {
      const socketClient = io(import.meta.env.VITE_WEBSOCKET_URL, {
        withCredentials: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        extraHeaders: {
          "X-Client-Code": clientCode,
          "X-Hash-Key": requestId,
          "X-Dashboard-Version": "v2",
        },
      });
      setSocket(socketClient);
      socketClient.on("connect", () => {
        console.log("Connected to socket");
      });
      socketClient.on("disconnect", () => {
        console.log("Disconnected from socket");
      });

      return () => {
        socketClient.off("connect");
        socketClient.off("disconnect");
        socketClient.disconnect();
      };
    }
  }, [auth.client?.client_code, auth.isLoggedIn, clientCode]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};
